import {
  getAssetLanguageKey,
  LocalizedAsset,
  normalizeSiteLanguage,
  SiteLanguage,
} from "../i18n/language";

const NEWS_15_IMAGE_URLS = [
  "https://assets.deepsoulai.com/news-v2/news15/05.jpeg",
  "https://assets.deepsoulai.com/news-v2/news15/01.jpeg",
  "https://assets.deepsoulai.com/news-v2/news15/02.jpeg",
  "https://assets.deepsoulai.com/news-v2/news15/03.jpeg",
  "https://assets.deepsoulai.com/news-v2/news15/04.jpeg",
  "https://assets.deepsoulai.com/news-v2/news15/06.jpeg",
];

const NEWS_17_COVER_IMAGES: Record<SiteLanguage, string> = {
  en: "https://assets.deepsoulai.com/main-page/trust/ud_security_assessed_en.png",
  zh: "https://assets.deepsoulai.com/main-page/trust/ud_security_assessed_zh_hk.png",
  "zh-CN":
    "https://assets.deepsoulai.com/main-page/trust/ud_security_assessed_zh_hans.png",
};

const NEWS_17_SQUARE_THUMBNAILS: Record<SiteLanguage, string> = {
  en: "https://assets.deepsoulai.com/news-v2/news17/security_assessed_square_en.png",
  zh: "https://assets.deepsoulai.com/news-v2/news17/security_assessed_square_zh.png",
  "zh-CN":
    "https://assets.deepsoulai.com/news-v2/news17/security_assessed_square_zh_cn.png",
};

const NEWS_18_IMAGE_URLS = [
  "https://assets.deepsoulai.com/news-v2/news18/01.jpeg",
  "https://assets.deepsoulai.com/news-v2/news18/02.jpeg",
  "https://assets.deepsoulai.com/news-v2/news18/03.jpeg",
  "https://assets.deepsoulai.com/news-v2/news18/04.jpeg",
  "https://assets.deepsoulai.com/news-v2/news18/05.jpeg",
  "https://assets.deepsoulai.com/news-v2/news18/06.jpeg",
  "https://assets.deepsoulai.com/news-v2/news18/07.jpeg",
];

const NEWS_19_THUMBNAIL = "https://assets.deepsoulai.com/news-v2/news19/01.jpg";

const NEWS_16_IMAGE_URLS = [
  "https://assets.deepsoulai.com/news-v2/news16/02.jpeg",
  "https://assets.deepsoulai.com/news-v2/news16/01.jpeg",
  "https://assets.deepsoulai.com/news-v2/news16/03.jpeg",
  "https://assets.deepsoulai.com/news-v2/news16/04.jpeg",
  "https://assets.deepsoulai.com/news-v2/news16/05.jpeg",
  "https://assets.deepsoulai.com/news-v2/news16/06.jpeg",
];

export type NewsPartnerId =
  | "dreamImpact"
  | "chillax"
  | "heyKiddo"
  | "aimHeart"
  | "hkper";

export interface NewsPartner {
  id: NewsPartnerId;
  logo: string;
  url?: string;
}

export interface NewsItem {
  id: string;
  thumbnail?: string;
  coverImage?: string;
  coverImageByLang?: LocalizedAsset;
  coverImageBySiteLanguage?: Partial<Record<SiteLanguage, string>>;
  thumbnailByLang?: LocalizedAsset;
  thumbnailBySiteLanguage?: Partial<Record<SiteLanguage, string>>;
  imagesByLang?: LocalizedAsset<string[]>;
  date: string;
  url?: string[];
  images?: string[];
  youtubeLink?: string;
  partners?: NewsPartner[];
}

export const PARTNER_URLS = {
  dreamImpact: "https://www.dreamimpacthk.com/",
  chillax: "https://www.instagram.com/chillax_place/",
  heyKiddo: "https://www.instagram.com/heykiddo_kidshk/",
  aimHeart: "https://aimhearthk.com/",
  hkper: "https://www.hkper.org/",
} as const;

export const localizedNewsCover = (
  item: NewsItem,
  language?: string | null,
): string | undefined =>
  item.coverImageBySiteLanguage?.[normalizeSiteLanguage(language)] ||
  item.coverImageByLang?.[getAssetLanguageKey(language)];

export const localizedNewsThumbnail = (
  item: NewsItem,
  language?: string | null,
): string | undefined =>
  item.thumbnailBySiteLanguage?.[normalizeSiteLanguage(language)] ||
  item.thumbnailByLang?.[getAssetLanguageKey(language)];

export const PARTNER_IMAGE_URLS = {
  dreamImpact:
    "https://assets.deepsoulai.com/main-page/partnership/partners/dream_impact.png",
  chillax:
    "https://assets.deepsoulai.com/main-page/partnership/partners/chillax.jpg",
  heyKiddo:
    "https://assets.deepsoulai.com/main-page/partnership/partners/hey_kiddo.jpg",
  aimHeart:
    "https://assets.deepsoulai.com/main-page/partnership/partners/aim_heart_employment_agency.jpg",
  hkper:
    "https://assets.deepsoulai.com/main-page/partnership/partners/hkperal.jpg",
  udomain:
    "https://assets.deepsoulai.com/main-page/partnership/partners/udomainhk_logo.jpeg",
} as const;

export const newsData: NewsItem[] = [
  {
    id: "20",
    thumbnail: "/images/news/ai-diary-life-story.webp",
    coverImage: "/images/news/ai-diary-life-story.webp",
    date: "2026-11-04",
  },
  {
    id: "19",
    thumbnail: NEWS_19_THUMBNAIL,
    coverImage: NEWS_19_THUMBNAIL,
    date: "2026-10-25",
    youtubeLink: "https://www.youtube.com/embed/8tpoLd1kyF0",
  },
  {
    id: "18",
    thumbnail: NEWS_18_IMAGE_URLS[0],
    coverImage: NEWS_18_IMAGE_URLS[0],
    date: "2026-10-13",
    images: NEWS_18_IMAGE_URLS,
    youtubeLink: "https://www.youtube.com/embed/tbY-YjszYrw",
  },
  {
    id: "17",
    thumbnail: NEWS_17_SQUARE_THUMBNAILS.zh,
    coverImage: NEWS_17_COVER_IMAGES.zh,
    coverImageByLang: {
      zh: NEWS_17_COVER_IMAGES.zh,
      en: NEWS_17_COVER_IMAGES.en,
    },
    coverImageBySiteLanguage: NEWS_17_COVER_IMAGES,
    thumbnailByLang: {
      zh: NEWS_17_SQUARE_THUMBNAILS.zh,
      en: NEWS_17_SQUARE_THUMBNAILS.en,
    },
    thumbnailBySiteLanguage: NEWS_17_SQUARE_THUMBNAILS,
    date: "2026-09-30",
  },
  {
    id: "16",
    thumbnail: NEWS_16_IMAGE_URLS[0],
    coverImage: NEWS_16_IMAGE_URLS[0],
    date: "2026-08-14",
    images: NEWS_16_IMAGE_URLS,
  },
  {
    id: "15",
    thumbnail: NEWS_15_IMAGE_URLS[0],
    coverImage: NEWS_15_IMAGE_URLS[0],
    date: "2026-08-07",
    images: NEWS_15_IMAGE_URLS,
  },
  {
    id: "14",
    thumbnail: "/images/news/2026-q3/q3-background-zh.png",
    coverImage: "/images/news/2026-q3/q3-background-zh.png",
    coverImageByLang: {
      zh: "/images/news/2026-q3/q3-background-zh.png",
      en: "/images/news/2026-q3/q3-background-en.png",
    },
    thumbnailByLang: {
      zh: "/images/news/2026-q3/q3-background-zh.png",
      en: "/images/news/2026-q3/q3-background-en.png",
    },
    imagesByLang: {
      zh: ["/images/news/2026-q3/q3-background-zh.png"],
      en: ["/images/news/2026-q3/q3-background-en.png"],
    },
    date: "2026-Q3",
    images: ["/images/news/2026-q3/q3-background-zh.png"],
  },
  {
    id: "13",
    thumbnail: "https://appconfig.deepsoulai.com/assests/q2_background.png",
    coverImage: "https://appconfig.deepsoulai.com/assests/q2_background.png",
    date: "2026-Q2",
    images: ["https://appconfig.deepsoulai.com/assests/q2_innolink_1.jpg"],
    partners: [
      {
        id: "dreamImpact",
        logo: "https://assets.deepsoulai.com/main-page/partnership/partners/dream_impact.png",
        url: "https://www.dreamimpacthk.com/",
      },
      {
        id: "chillax",
        logo: "https://assets.deepsoulai.com/main-page/partnership/partners/chillax.jpg",
        url: "https://www.instagram.com/chillax_place/",
      },
      {
        id: "heyKiddo",
        logo: "https://assets.deepsoulai.com/main-page/partnership/partners/hey_kiddo.jpg",
        url: "https://www.instagram.com/heykiddo_kidshk/",
      },
      {
        id: "aimHeart",
        logo: "https://assets.deepsoulai.com/main-page/partnership/partners/aim_heart_employment_agency.jpg",
        url: "https://aimhearthk.com/",
      },
      {
        id: "hkper",
        logo: "https://assets.deepsoulai.com/main-page/partnership/partners/hkperal.jpg",
        url: "https://www.hkper.org/",
      },
    ],
  },
  {
    id: "12",
    thumbnail: "https://appconfig.deepsoulai.com/assests/souli_heart.png",
    coverImage: "https://appconfig.deepsoulai.com/assests/souli_heart.png",
    date: "2026-Q1",
    images: ["https://appconfig.deepsoulai.com/assests/q1_HKMU.jpg"],
  },
  {
    id: "11",
    thumbnail: "/images/news/news11_1.jpg",
    coverImage: "/images/news/news11_1.jpg",
    date: "2026-01-07",
    url: [
      "https://scontent-sin2-2.cdninstagram.com/v/t51.71878-15/589017868_1352203569781990_7693011616029114423_n.jpg?stp=dst-jpg_e15_tt6&_nc_cat=103&ig_cache_key=Mzc3Njk5NTkwMTI1Nzc2MjQ1Mw%3D%3D.3-ccb7-5&ccb=7-5&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjY0MHgxMTM2LnNkci5DMyJ9&_nc_ohc=xe7Oc-etyJ0Q7kNvwFGsvdY&_nc_oc=AdkJgw4iSxOOmeNctwRynreyEhCotF47Jllj48wcAwWOjZS5mG5XrdI0KljimdwULaI&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=scontent-sin2-2.cdninstagram.com&_nc_gid=PVmnuNYbotOqw-hRpPdZOA&oh=00_AfoCMa_JFrcbe93hT8onC52b4NdfDwHTwvWZiOZwwCrHCw&oe=696FBFC5",
      "https://scontent-sin2-1.cdninstagram.com/v/t51.71878-15/610905123_753612397242691_5929751414450260768_n.jpg?stp=dst-jpg_e15_tt6&_nc_cat=102&ig_cache_key=MzgwNzA1NzI3NzkzODI3MDI0NA%3D%3D.3-ccb7-5&ccb=7-5&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjY0MHgxMTM2LnNkci5DMyJ9&_nc_ohc=4tGjNI9DFi4Q7kNvwFMEDbf&_nc_oc=AdlTKF-fZvLnAptsy7Ho1nlwzbHwfDW0Kca8-E40tJqx7sznBpgYIcAB4IQwJ9tOLJw&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=scontent-sin2-1.cdninstagram.com&_nc_gid=PVmnuNYbotOqw-hRpPdZOA&oh=00_Afr7xW-5fPQALxCm1tjDmoaS4r_XGdNx-sqQJVWBM0L86A&oe=696F9E82",
    ],
    images: ["/images/news/esgAwards6.jpeg", "/images/news/news11_1.jpg"],
  },
  {
    id: "10",
    thumbnail: "/images/news/news10_2.jpg",
    coverImage: "/images/news/news10_2.jpg",
    date: "2025-12-28",
    images: [
      "/images/news/news10_1.jpg",
      "/images/news/news10_2.jpg",
      "/images/news/news10_3.jpg",
      "/images/news/news10_4.jpg",
      "/images/news/news10_5.jpg",
      "/images/news/news10_6.jpg",
    ],
  },
  {
    id: "8",
    thumbnail: "/images/news/news8_2.jpg",
    coverImage: "/images/news/news8_1.jpg",
    date: "2025-12-03",
    youtubeLink: "https://www.youtube.com/embed/_Ewuq3ywu74",
  },
  {
    id: "7",
    thumbnail: "/images/news7/news7_1.jpg",
    coverImage: "/images/news7/news7_3.jpg",
    date: "2025-11-30",
    url: [
      "https://scontent-sin2-2.cdninstagram.com/v/t51.71878-15/589017868_1352203569781990_7693011616029114423_n.jpg?stp=dst-jpg_e15_tt6&_nc_cat=103&ig_cache_key=Mzc3Njk5NTkwMTI1Nzc2MjQ1Mw%3D%3D.3-ccb7-5&ccb=7-5&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjY0MHgxMTM2LnNkci5DMyJ9&_nc_ohc=xe7Oc-etyJ0Q7kNvwFGsvdY&_nc_oc=AdkJgw4iSxOOmeNctwRynreyEhCotF47Jllj48wcAwWOjZS5mG5XrdI0KljimdwULaI&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=scontent-sin2-2.cdninstagram.com&_nc_gid=PVmnuNYbotOqw-hRpPdZOA&oh=00_AfoCMa_JFrcbe93hT8onC52b4NdfDwHTwvWZiOZwwCrHCw&oe=696FBFC5",
      "https://scontent-sin2-1.cdninstagram.com/v/t51.71878-15/610905123_753612397242691_5929751414450260768_n.jpg?stp=dst-jpg_e15_tt6&_nc_cat=102&ig_cache_key=MzgwNzA1NzI3NzkzODI3MDI0NA%3D%3D.3-ccb7-5&ccb=7-5&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjY0MHgxMTM2LnNkci5DMyJ9&_nc_ohc=4tGjNI9DFi4Q7kNvwFMEDbf&_nc_oc=AdlTKF-fZvLnAptsy7Ho1nlwzbHwfDW0Kca8-E40tJqx7sznBpgYIcAB4IQwJ9tOLJw&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=scontent-sin2-1.cdninstagram.com&_nc_gid=PVmnuNYbotOqw-hRpPdZOA&oh=00_Afr7xW-5fPQALxCm1tjDmoaS4r_XGdNx-sqQJVWBM0L86A&oe=696F9E82",
    ],
    images: [
      "/images/news7/news7_3.jpg",
      "/images/news7/news7_1.jpg",
      "/images/news7/news7_2.jpg",
    ],
  },
  {
    id: "6",
    thumbnail: "/images/esgAward/esg1.jpg",
    coverImage: "/images/esgAward/esg1.jpg",
    date: "2025-11-13",
    images: [
      "/images/esgAward/esg1.jpg",
      "/images/esgAward/esg2.jpg",
      "/images/esgAward/esg3.jpg",
      "/images/esgAward/esg4.jpg",
      "/images/esgAward/esg5.jpg",
      "/images/esgAward/esg6.jpg",
    ],
  },
  {
    id: "5",
    date: "2025-10-24",
    images: ["/images/diInterview/diInterviewCover.jpg"],
  },
  {
    id: "4",
    thumbnail: "/images/other/seminarPreserved.jpg",
    coverImage: "/images/seminar/semCover.jpg",
    date: "2025-10-19",
    images: [
      "/images/seminar/sem1.jpg",
      "/images/seminar/sem2.jpg",
      "/images/seminar/sem3.jpg",
      "/images/seminar/sem4.jpg",
      "/images/seminar/sem5.jpg",
      "/images/seminar/sem6.jpg",
    ],
  },
  {
    id: "3",
    date: "2025-09-15",
    images: ["/images/other/hkfiiExpanded.png"],
  },
  {
    id: "2",
    thumbnail: "/images/other/MVPLaunch.png",
    coverImage: "/images/other/MVPLaunch.png",
    date: "2025-08-08",
    youtubeLink:
      "https://www.youtube.com/embed/cJOEKQKZQR0?si=tMYEUtfed1N6Z9w5",
  },
  {
    id: "1",
    date: "2025-05-21",
    images: ["/images/other/sueInterview.jpg"],
    youtubeLink:
      "https://www.youtube.com/embed/l-ZVZr5_kC0?si=afpUEHT3v1-s2MGK",
  },
];
